import { getProactiveMessages } from '../../utils/bookboost/api';

export const ACTIVATE_MESSAGE = 'PROACTIVE_MESSAGE::ACTIVATE_MESSAGE';
export const READ_COUPON = 'PROACTIVE_MESSAGE::READ_COUPON';
export const CLOSE_MESSAGE = 'PROACTIVE_MESSAGE::CLOSE_MESSAGE';
export const REGISTER_PROACTIVE_MESSAGES = 'PROACTIVE_MESSAGE::REGISTER_PROACTIVE_MESSAGES';
export const CLEAR_EXPIRED_MESSAGES = 'PROACTIVE_MESSAGE::CLEAR_EXPIRED_MESSAGES';

export const activateMessage = (id) => ({
    type: ACTIVATE_MESSAGE,
    id,
    time: Date.now()
});

export const readCoupon = (id) => ({
    type: READ_COUPON,
    id
});

export const closeMessage = (id) => ({
    type: CLOSE_MESSAGE,
    id
});

export const registerProactiveMessages = (proactiveMessages) => ({
    type: REGISTER_PROACTIVE_MESSAGES,
    proactiveMessages
});

export const clearExpiredMessages = () => ({ type: CLEAR_EXPIRED_MESSAGES });

export const fetchProactiveMessages = () => (dispatch) => {
    return dispatch(getProactiveMessages())
        .then((proactiveMessages) => {
            dispatch(registerProactiveMessages(proactiveMessages));
            return proactiveMessages;
        })
        .catch();
};
